import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '../button/new';
import { buttonPropTypes, cmsImagesPropTypes } from '../../prop-types';
import { buttonQuery, matrixBlockQuery, relatedEntriesQuery } from '../../content/query-snippets';
import { buttonTransform, imageTransform } from '../../content/transforms';
import { Container, Flex } from '../grid';
import { BlockHeader } from '../block-header';
import { NewsCard, ProductCard, RecipeCard } from '../card';

const cardOptions = {
  news: NewsCard,
  product: ProductCard,
  recipe: RecipeCard,
};

const RelatedEntriesBlock = ({ heading, relatedEntries, button, viBody }) => {
  const formattedButton = buttonTransform(button);

  return (
    <Container my={{ xs: '64px', lg: '120px' }}>
      <Flex flexDirection="column" width="100%" alignItems="center">
        {heading && <BlockHeader heading={heading} body={viBody} />}
        <Flex width="100%" flexDirection="column" alignItems="center">
          <Flex
            display="grid"
            gridTemplateColumns={{ xs: 'repeat(1, 1fr)', md: 'repeat(3, minmax(0, 364px))' }}
            gap={{ xs: '32px 16px', md: '48px 24px' }}
            justifyContent="center"
          >
            {relatedEntries.map(item => {
              const CardComponent = cardOptions[item.typeHandle];

              return (
                <Flex key={item.title}>
                  <CardComponent
                    item={{
                      href: `/${item.uri}`,
                      heading: item.title,
                      ...item,
                      image: imageTransform(item.image),
                    }}
                  />
                </Flex>
              );
            })}
          </Flex>
          {!isEmpty(formattedButton) && (
            <Flex mt="60px" justifyContent="center">
              <Button {...formattedButton} widthType="fit" size="tall" variant="secondary">
                {formattedButton.text}
              </Button>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Container>
  );
};

RelatedEntriesBlock.query = `
  ... on contentMatrix_relatedEntriesBlock_BlockType {
    ${buttonQuery}
    ${matrixBlockQuery}
    ${relatedEntriesQuery}
    heading
    viBody
  }
`;

RelatedEntriesBlock.propTypes = {
  button: PropTypes.arrayOf(buttonPropTypes),
  heading: PropTypes.string.isRequired,
  relatedEntries: PropTypes.arrayOf(
    PropTypes.shape({
      typeHandle: PropTypes.string,
      image: cmsImagesPropTypes,
      heading: PropTypes.string,
      slug: PropTypes.string,
      title: PropTypes.string,
    })
  ).isRequired,
  viBody: PropTypes.string,
};

RelatedEntriesBlock.defaultProps = {
  button: null,
  viBody: null,
};

export { RelatedEntriesBlock };
